/* eslint-disable no-unused-vars */
import { cloneDeep, sum } from "lodash";
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { BiMoney } from "react-icons/bi";
import { FaMoneyCheckAlt } from "react-icons/fa";
import { useParams } from "react-router-dom";
import addPrecision from "../../common/addPrecision";
import AppButton from "../../common/AppButton";
import AppInput from "../../common/AppInput";
import numberFormat from "../../common/numberFormat";
import numberOnly from "../../common/numberOnly";
import removeCommas from "../../common/removeCommas";
import api from "../../config/api";
import colors from "../../config/colors";
import config from "../../config/config";
import { toast } from "react-toastify";
import { useQueryClient } from "@tanstack/react-query";
const size = config.iconSize;

const formInit = {
  date: new Date(),
  amount: "",
  chequeNumber: "",
};
export default function ReceivePaymentModel() {
  const params = useParams();
  const queryClient = useQueryClient();

  const Body = ({ onSuccess, job, payments }) => {
    const [disabled, setDisabled] = useState(false);
    const balance =
      Number(removeCommas(job.total)) -
      sum(payments?.map((i) => Number(removeCommas(i.amount))));
    const [form, setForm] = useState(cloneDeep(formInit));
    const handleChange = ({ target }) => {
      const name = target.name;
      const value = target.value;
      if (name === "amount") {
        if (Number(removeCommas(value)) > balance) {
          return false;
        }
      }
      setForm({ ...form, [name]: value });
    };
    const handleSubmit = async (event) => {
      setDisabled(true);
      event.preventDefault();

      const res = await api.post("jobPayments", {
        job: job._id,
        ...form,
      });

      if (!res.ok) {
        setDisabled(false);
        return toast.error(res.originalError.message);
      }
      queryClient.invalidateQueries(["jobPayments"]);

      setDisabled(false);
      toast.success("Payment has been succesfully received.");
      onSuccess && onSuccess();
    };

    return (
      <form id="form" onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <div
            className="d-flex"
            style={{
              justifyContent: "space-between",
              flexGrow: 1,
              alignItems: "center",
            }}
          >
            <span className="d-flex" style={{ alignItems: "center" }}>
              <b>Receive Payment</b>
            </span>
            <span>Balance : {`$ ${addPrecision(balance)}`}</span>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div
            className="d-flex"
            style={{
              padding: "0px 30px",
              gap: 30,
              alignItems: "flex-start",
              minHeight: 400,
            }}
          >
            <AppInput
              onChange={handleChange}
              name="date"
              label="Date"
              floatLabel
              type="date"
              value={form.date}
              required
              placeholder=""
            />
            <AppInput
              leftIcon={<BiMoney size={size} color={colors.silver} />}
              name="amount"
              onChange={handleChange}
              placeholder={balance}
              label="Amount"
              value={numberFormat(form.amount)}
              required
              type="text"
              floatLabel
            />

            <AppInput
              leftIcon={<FaMoneyCheckAlt size={size} color={colors.silver} />}
              name="chequeNumber"
              onChange={handleChange}
              label={"Cheque Number"}
              floatLabel
              value={numberOnly(form.chequeNumber)}
              type="text"
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <AppButton
            disabled={disabled}
            text="Receive"
            form="form"
            type="submit"
            className="text-primary btn-light"
          />
        </Modal.Footer>
      </form>
    );
  };

  return { Body };
}
